module.exports = __webpack_public_path__ + "img/pen_2.888804fe.svg";